import RoomRequestStatus from 'owa-service/lib/contract/RoomRequestStatus';
import type * as Schema from 'owa-graph-schema';
import { assertNever } from 'owa-assert';

export function convertAutoRoomBookingStatusToGql(
    roomRequestStatus: RoomRequestStatus
): Schema.RoomRequestStatus {
    switch (roomRequestStatus) {
        case RoomRequestStatus.None:
            return 'None';
        case RoomRequestStatus.Processing:
            return 'Processing';
        case RoomRequestStatus.Requested:
            return 'Requested';
        case RoomRequestStatus.Unavailable:
            return 'Unavailable';
        case RoomRequestStatus.Failed:
            return 'Failed';
        case RoomRequestStatus.RBAAccepted:
            return 'RBAAccepted';
        case RoomRequestStatus.RBADeclined:
            return 'RBADeclined';
        case RoomRequestStatus.RBATentative:
            return 'RBATentative';
        case RoomRequestStatus.RBACanceled:
            return 'RBACanceled';
        case RoomRequestStatus.RBASkipped:
            return 'RBASkipped';
        default:
            return assertNever(roomRequestStatus);
    }
}
